<template>
  <app-layout
    :state="state"
    header-type="landing"
  >
    <template #header>
      <div
        class="flex items-baseline"
        :class="{
          'pb-6' : tabs.length > 1
        }"
      >
        <div class="flex-1">
          <h1 class="text-3xl md:text-4xl font-light">
            {{ state.competition.title }}
          </h1>
          <div
            v-if="state.marking_phases.length > 1"
            class="form-wrapper-select text-white"
          >
            <select
              v-model="currentMarkingPhase"
              class="text-xl md:text-2xl font-semibold appearance-none bg-transparent focus:outline-none text-white focus:text-black"
            >
              <option
                v-for="{name, id} in state.marking_phases"
                :key="id"
                :value="id"
              >
                {{ name }}
              </option>
            </select>
          </div>
          <p
            v-else
            class="text-xl md:text-2xl font-semibold"
          >
            {{ state.marking_phase.name }}
          </p>
        </div>
        <div
          v-if="$slots.headerAction"
          class="flex-no-shrink ml-8 w-48"
        >
          <slot name="headerAction"></slot>
        </div>
      </div>
    </template>
    <app-header>
      <template #navigation>
        <slot name="navigation">
          <ul v-if="tabs">
            <li
              v-for="(tab, index) in tabs"
              :key="index"
            >
              <a
                :href="route(tab.route, { funding: state.funding_pot.id, phase: state.marking_phase.id })"
                :class="[tab.class ? tab.class : '',{
                  'is-active': currentRoute === tab.route
                }]"
              >
                {{ tab.name }}
              </a>
            </li>
          </ul>
        </slot>
      </template>
    </app-header>
    <template #tertiary>
      <portal-target
        name="tertiary"
        slim
      />
    </template>
    <slot />
  </app-layout>
</template>

<script>
export default {
  name: "FundingBase",
  data() {
    return {
      currentMarkingPhase: this.state.marking_phase.id
    }
  },
  computed: {
    currentRoute() {
      return this.state.route;
    },
    tabs() {
      return [
        {
          name: "League Table",
          route: "funding.assessments.phase"
        },
        {
          name: "Review",
          route: "funding.assessments.review"
        },
        {
          name: "Assessors",
          route: "funding.assessments.assessors"
        },
      ];
    }
  },
  watch: {
    currentMarkingPhase: {
      handler(value) {
        window.location = this.route(this.currentRoute, [this.state.funding_pot.id, value])
      }
    }
  },
};
</script>
